module.exports = __webpack_public_path__ + "static/logo-0744bebe64382fc5e3c6cfc506391d4a.svg";